import { createTeamInputs } from "../form";
import { create_team, update_team } from "../apis";
import { global } from ":shared/app";
import { Show } from "solid-js";
import type { UserRequests } from "../../SHARED/_model";

export type Props = {
  details: UserRequests;
  onCreate: (props: UserRequests) => void;
};

export function CreateTeamForm(props: Props) {
  const jwt = global.api.auth.token.decoded();
  const tracks = global.store.actions.platform.getTracks();
  const has_team = props?.details?.team_info?.name != undefined;
  const Form = createTeamInputs(props.details?.team_info);
  async function onSubmit() {
    const data = Form.Actions.getValuesSnakecase();
    if (has_team) {
      return await update_team.put(data).then((data) => {
        global.store.actions.toast.pushToast({
          type: "success",
          message: "team details updated!",
        });
        props.onCreate?.(data);
      });
    }
    await create_team.post(data).then((data) => {
      global.store.actions.toast.pushToast({
        type: "success",
        message: "team has been created, good luck!",
      });
      props.onCreate?.(data);
    });
  }
  return (
    <form class="flex flex-col w-fit h-full mx-auto py2 <sm:(w-full mx-0) overflow-y-auto scrollbar">
      <p class="w-full text-black text-0.8em pb2">
        you currently do not have a team, please create one to start inviting individuals or you can go the teams page
        and join other teams.
      </p>
      <Form.TeamName.Label title="Team Name" class="form-label">
        <Form.TeamName.Input
          autocomplete="team_name"
          type="text"
          class="form-input"
          placeholder={"Enter your team name"}
        />
      </Form.TeamName.Label>
      <Form.Track.Label title="Track" class="form-label">
        <Form.Track.Select class="form-select" options={tracks.values} />
      </Form.Track.Label>
      <Form.Brief.Label title="Brief" class="form-label">
        <Form.Brief.Input type="text" class="form-input" placeholder={"Enter your team brief"} />
      </Form.Brief.Label>
      <Form.Thumbnail.Label title="Project Cover" class="form-label" note={props?.details?.team_info?.thumbnail_name}>
        <Form.Thumbnail.InputFile
          accept="image/*"
          class="form-input-file taller min-w-full"
          elements={{
            overlay({ onclick, viewer_data, drag }) {
              return (
                <div
                  onclick={onclick}
                  class="flex flex-col w-full h-full justify-center items-center text-center gap-5px cursor-pointer"
                >
                  <p class="cursor-pointer">
                    <Show when={!drag} fallback={"Drop Files"}>
                      <span class="underline text-16px">Upload .PNG, JPG, JPEG file</span>
                    </Show>
                  </p>
                  <Show when={viewer_data.file}>{viewer_data.file.name}</Show>
                </div>
              );
            },
          }}
        />
      </Form.Thumbnail.Label>
      <Form.Actions.Button
        class="form-btn flex flex-row min-h-2rem text-0.8rem px-2 py-1 items-center justify-center my-24px rounded-md shadow-sm bg#orange! text-white!"
        onclick={onSubmit}
        statusValid={has_team ? "Update Team" : "Create Team"}
        statusInvalid={has_team ? "Update Team" : "Create Team"}
      />
    </form>
  );
}
